var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 42,
    viewBox: "0 0 178 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49525 40.8694C4.72298 41.3725 5.31546 41.5958 5.81861 41.3681L14.0179 37.6571C14.5211 37.4294 14.7443 36.8369 14.5166 36.3337C14.2889 35.8306 13.6964 35.6073 13.1933 35.835L5.90499 39.1337L2.60635 31.8454C2.37862 31.3422 1.78612 31.119 1.28297 31.3467C0.779822 31.5744 0.556547 32.1669 0.784268 32.67L4.49525 40.8694ZM162.368 1.95605C170.488 13.0111 174.355 20.7304 175.065 25.9356C175.415 28.4991 174.987 30.3563 174.023 31.7155C173.051 33.087 171.428 34.0994 169.1 34.7531C164.399 36.0728 157.258 35.8125 148.38 34.5876C139.541 33.3683 129.144 31.2202 118.006 28.8764C95.7799 24.1992 70.6171 18.7419 49.4856 18.522C28.421 18.3029 10.8058 23.2931 4.47053 40.1044L6.34204 40.8097C12.1871 25.2992 28.5079 20.3039 49.4648 20.5219C70.3547 20.7392 95.2987 26.1417 117.594 30.8336C128.718 33.1744 139.185 35.3382 148.106 36.5688C156.987 37.794 164.501 38.1218 169.641 36.6786C172.233 35.9508 174.327 34.744 175.655 32.8724C176.991 30.9884 177.445 28.5786 177.047 25.665C176.262 19.916 172.11 11.8408 163.98 0.7721L162.368 1.95605Z",
    fill: "#0E2C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/Arrow2.af4bd03f3492917edd43e3924ec889d1.svg";
export { ForwardRef as ReactComponent };